import { useEffect, useRef } from 'react';

import { eventNames } from '../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../utils/GTM/useTrackMixpanelEvent';

export default function useViewJoinInstructorPageEvent() {
  const { trackMixpanelEvent, isReady } = useTrackMixpanelEvent();
  const viewed = useRef(false);

  useEffect(() => {
    if (!isReady || viewed.current) {
      return;
    }
    viewed.current = true;
    trackMixpanelEvent(eventNames.VIEW_JOIN_INSTRUCTOR, {});
  }, [isReady, trackMixpanelEvent]);
}
